<template>
  <div class="c-product-card">
      987654321
  </div>
</template>

<script setup name="powerupLogin">
import { onMounted } from "vue";
import { api } from "@/plugins/api";

onMounted(() => {
  setYear();
});
2
const setYear = async () => {
  const param = {
    id: "B06912"
  }
  const res = await api.post("/api/v1/powerup" + "/product2", param);
  return res;
}
</script>